import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {plural} from '../../common/components/Plural.js'
import {useSelector} from '../../store.js'
import {
  poListQuerySelector,
  countSelector,
} from './purchaseOrderListSelectors.js'

export default function POListItemsCount() {
  const {limit, offset} = useSelector(poListQuerySelector)
  const count = useSelector(countSelector)

  return (
    <li className="inline-block margin-right-3">
      <ListItemsCount
        limit={limit}
        offset={offset}
        count={count}
        thing={plural(count)`PO${['s']}`}
      />
    </li>
  )
}
